export * from './DeviceTypePage';
export * from './deviceTypeCompleted';
